/* eslint-disable max-len */
module.exports = {
  'Internal Server Error': 'Internal Server Error',
  // 网络相关错误
  networkError: 'Network error, Please check network and proxy setting.',
  UNABLE_TO_VERIFY_LEAF_SIGNATURE:
    'HTTPS certificate error, Please confirm if you have used the capture tool or proxy tool, or Try turning off option "Verify HTTPS certificates". restart client after global proxy changed.',
  SELF_SIGNED_CERT_IN_CHAIN:
    'HTTPS certificate error, Please confirm if you have used the capture tool or proxy tool, or Try turning off option "Verify HTTPS certificates". restart client after global proxy changed.',
  ENOSPC: 'Not enough disk space',
  EPERM: 'No local directory permissions',
  ETIMEDOUT: 'ETIMEDOUT (Request timeout)',
  ECONNRESET: 'ECONNRESET. Network error',
  ENOTFOUND: 'ENOTFOUND. Can not found the address, please check the network.',
  failed_to_set_tags: 'Failed to set tags: network error',

  // COS 相关错误
  'AuthFailure.UnauthorizedOperation': 'No associated cam policy found',
  'UnauthorizedOperation.CdnCamUnauthorized':
    'AccessDenied, please contact the root account owner to request permission (via adding preset policy cdn:* or cdn:DescribeDomains.)',
  AccessDenied: "You don't have permissions",
  'Unavailable For Legal Reasons':
    'Bucket have been blocked. Please submit a ticket to confirm the reason and apply for unsealed.',
  'Unable to send AtomFrameHostMsg_Message_Sync': 'Client exits abnormally',
  BUCKET_APPID_ERROR: 'Access denied to add access path',
  OWNER_HAS_NO_AUTH_ADD_ACCESS_PATH: 'Owner can not add this access path.',
  PARAM_IS_INVALID: 'Param invalid.',
  BucketAlreadyExists: 'Bucket name is already owned by you, please re-enter one.',
  NoSuchBucket: 'The specified bucket does not exist.',
  NoSuchKey: 'Specified object key does not exit.',
  BadDigest: 'Content not match',
  NoSuchUpload: 'No such upload file.',
  ENOENT: 'No such file or directory',
  InvalidDigest: 'The Content-MD5 you specified was invalid',
  OAZOperationNotSupportOnMAZBucket:
    'AccessDenied, please contact the root account owner to request permission (via adding headBuckt policy)',
  UnavailableForLegalReasons: 'The account has not been real-named or has been banned',
  up_to_10_tags_are_allowed: 'Up to 10 tags are allowed',
  InvalidTag: 'The TagKey contains invalid characters',
  RestoreAlreadyInProgress: 'The object is recovering ',
  RestoreFileSizeExceed: 'Objects larger than 256MB cannot be restored using Expedited mode',
  RestoreNonArchiveObject: 'Regeneration of non-archive objects is not allowed',
  'InvalidParameter.GrantOtherResource': 'Unauthorized access to resources',

  unknownError: 'Unknown error',
  requestError: 'Request Error',
  bucketListEmpty: 'Currently SecretId does not have an accessible bucket or access path',
  secretError: 'SecretId or SecretKey make a mistake',
  signatureError: 'Signature mismatch, please check if the key and other information are accurate',
  secretIdError: 'SecretId make a mistake',
  bucketNameError: 'Incorrect bucket name',
  projectSecretWarning: 'Project SecretId can not applicable to this client',
  machineTimeTooSkewed: 'The time on your machine is not accurate.',
  httpsCertificateError:
    'HTTPS certificate error. Please confirm if you use the capture tool or proxy tool, or Try turning off option "Verify HTTPS certificates"',
  needAccessPathOrGetServiceAccess:
    'Login by access path, or the main account grants QcloudCOSGetServiceAccess permission.',
  needAccessPath: 'Login by access path',
  orGetServiceAccess: 'or the main account grants QcloudCOSGetServiceAccess permission.',
  malformed_proxy: 'Malformed proxy',

  // 没有权限
  no_permission_to_cloud_monitoring_simple: "You don't have permission to access cloud monitoring data",
  no_permission_to_cloud_monitoring:
    "You don't have permission to access cloud monitoring data, please contact the root account owner to request permission (via adding headBuckt policy and preset policy monitor:* or monitor:GetMonitorData)",
  no_permission_to_edit_storage_class:
    "You don't have permission to edit storage class, please contact the root account owner to request permission (via adding getObjectAcl, putObjectAcl and putObjectCopy policy)",
  no_permissions_to_download: 'Download access denied',
  no_permissions_to_upload: 'Upload access denied',
  no_permissions_to_list_files:
    'Please check if you have permission to access object list Permissions which you will download',
  no_permissions_to_list_object_versions:
    "You don't have permission to edit storage class, please contact the root account owner to request permission (via adding listObjectVersions policy)",
  no_permissions_to_get_bucket:
    "You don't have permission to edit storage class, please contact the root account owner to request permission (via adding getBucket policy)",
  no_permissions_to_delete_object: 'Failed to delete. Check whether you have permissions to delete objects',
  no_permissions_to_get_bucket_acl: "You don't have permission to access bucket Permissions",
  no_permissions_to_access_bucket_acl: "You don't have permission to access bucket Permissions",
  no_permissions_to_access_bucket_incomplete_uploads:
    "You don't have permission to access bucket incomplete uploads list",
  no_permissions_to_list_multipart_uploads:
    'Failed to delete. Check whether you have permissions to list incomplete multipart uploads',
  no_permissions_to_delete_multipart_uploads:
    'Failed to delete. Check whether you have permissions to delete incomplete multipart uploads',
  no_permissions_to_get_versioning: "You don't have permission to get bucket versioning status",
  no_permissions_to_get_acceleration: "You don't have permission to get bucket acceleration status",
  no_permissions_to_create_bucket: "You don't have permission to create bucket",
  no_permissions_to_delete_bucket: 'Sorry, you do not have permission to delete this bucket',
  no_permissions_to_bucket_versioning_configuration:
    "You don't have access to bucket versioning configuration, please contact the root account owner to request permission (via adding getBucketVersioning policy)",
  no_permissions_to_update: 'Update Error: Could not create temporary directory: Permission Denied',
  no_permissions_to_head_object:
    "You don't have permission to read object metadata. Please contact the root account to request permission",
  no_permissions_to_get_object_acl:
    "You don't have permission to read object ACL. Please contact the root account to request permission",
  no_permissions_to_slice_copy_file:
    "You don't have permission to write the object. Please contact the root account to request permission",
  no_permissions_to_copy_file: "You don't have permissions to copy. Please contact root account to request permission.",
  no_permissions_to_get_object_tagging:
    'You have no permissions to read the configurations of the object tag management.',
  no_permissions_to_get_bucket_tagging:
    'You have no permissions to read the configurations of the bucket tag management',
  no_permissions_to_put_tagging: 'You have no permissions to set tag management',
  no_permissions_to_delete_tagging: "You don't have permissions to delete tags",
  no_permissions_to_put_bucket_cors: "You don't have permissions to put bucket cors.",
  no_permissions_to_get_sts:
    "You don't have permission to get federation token, please contact the root account owner to request permission (via preseting policy sts:GetFederationToken)",
  no_permissions_to_put_bucket_versioning:
    "You don't have permission to set bucket versioning configuration. Contact the root account to request permission.",
  no_permissions_to_get_bucket_website: 'You don\'t have permission to access bucket static website hosting',
  no_permissions_to_put_bucket_website: 'You don\'t have permission to set bucket static website hosting',

  // 客户端自定义错误
  file_already_exist: 'File Already Exist',
  exist_same_file: 'Same name file exist, cannot create a directory: ',
  exist_same_dir: 'Same name directory exist, cannot create a file: ',
  exist_same_filename_in_target_location:
    'There is a file/are files with the same name in the target location, please edit again!',
  remote_folder_exist: 'Same name directory exist',
  remote_file_not_found: 'Remote file has been deleted.',
  local_file_not_found: 'Local file has been deleted.',
  remote_file_has_changed: 'Remote file has been modified. Please download it again.',
  local_file_has_changed: 'Local file has been modified. Please download it again.',
  archive_file_not_support_download: 'ARCHIVE files not support download.',
  archive_file_not_support_preview: 'Unrecovered archive files not support preview.',
  unknown_chunk_size: 'Get chunk size failed.',
  download_file_err: 'Download failed.',
  bucket_not_selected: 'Bucket not selected',
  render_menu_list_err: [
    'SecretId、SecretKey input error.', // 0
    'Please contact the owner to assign [ QcloudCOSGetServiceAccess ] strategy.', // 1
    'There is no accessible bucket.', // 2
  ],
  render_bucket_list_err: [
    'Sorry, you do not have permission to access the bucket list.', // 0
    'Currently SecretId does not have an accessible bucket or access path', // 1
  ],
  thumbnail_image_too_large: 'Some pictures are larger than 20MB, no thumbnails are displayed.',
  edit_file_too_large: 'The file is larger than {num} MB and does not support editing',
  open_file_too_large: '{files} larger than 20MB do not support quick opening. Please download and open it.',
  not_support_to_preview: 'This file format is not supported to preview.',
  not_support_view_detail: 'Not support to view the detail.',
  preview_err: 'Preview Error',
  parse_image_fail: 'Parse image fail',
  no_exif_data: 'no exif data',
  get_download_list_err: 'Batch download list query failed',
  not_selected_local_folder: 'Local folder not selected',
  empty_clipboard: 'Clipboard empty',
  empty_authorized_user: 'Authorized user account ID cannot be empty',
  no_filename_available_to_paste: 'No filename available to paste',
  no_file_to_paste: 'No files to paste',
  no_file_to_delete: 'No files to delete',
  no_file_to_upload: 'No file to upload',
  no_file_to_download: 'No file to download',
  not_support_to_drop_here: 'Drag and drop here not support.',
  choose_file_to_rename: 'Please choose an object to rename.',
  choose_at_least_one_user_acl: 'Please select at least one user ACL',
  not_support_multi_to_rename: 'Mutiple selection is not supported.',
  not_support_to_rename_folder: 'Renaming Folder is not supported.',
  del_valid_files_before_del_bucket: 'Failed to delete, please check if the bucket has been cleaned.',
  local_file_not_exist: 'Local file not exist.',
  remote_file_not_exist: 'Bucket file not exist.',
  remote_folder_not_exist: 'Bucket folder not exist.',
  failed_to_add_access_path: 'Failed to add collection path.',
  failed_to_delete_access_path: 'Failed to delete collection path.',
  failed_to_create_bucket: 'Failed to create bucket.',
  failed_to_delete_bucket: 'Failed to delete bucket.',
  failed_to_set_policy_of_1000: 'Failed to set: Up to 1000 policies can be set.',
  failed_to_access_permission_of_no_such_account:
    'Failed to access permissions. Please check if there is a non-existing sub-account in the existing permission list',
  get_file_size_err: 'Get file size error',
  get_file_etag_err: 'Get file Etag error',
  part_size_not_match: 'Part size not match',
  bulk_interface_delete_err: 'Bulk interface deletion failed',
  part_files_delete_failed: 'Part of files failed to delete',
  too_much_files: 'No more than 1 million files',
  invalid_url: 'Invalid URL',
  set_v4_acl_fail: 'Set v4 acl failed.',
  archived_file_not_allow_change: 'Please restore archived object first.',
  showkey_not_found: 'The file was not found in current pulled files. You can locate it via searching.',
  get_cdn_host_faild: 'Get cdn host failed',
  edit_acl_failed_of_cdn_host_exist: 'CDN host exist. You can only edit bucket acl in console',
  delete_bucket_failed_of_cdn_host_exist:
    'Delete bucket failed. Please disable the default CDN acceleration domain name and delete the custom domain first',
  unable_to_get_user_information: 'Unable to get user information.',
  failed_to_get_versioning: 'Failed to get bucket versioning status',
  failed_to_get_acceleration: 'Failed to get bucket acceleration status',
  no_incomplete_upload: 'There is no incomplete upload.',
  failed_to_get_incomplete_uploads: 'Fail to get incomplete multipart uploads list',
  no_such_incomplete_upload: 'This upload task has been completed or cancelled',
  no_versioning_to_clear: 'History version data on this folder has already been cleared.',
  bucket_not_enable_versioning: "Destination bucket hasn't enabled versioning.",
  with_dirty_data: 'Dirty data is left',
  choose_one_session: 'Please select an access path under a session to log in.',
  session_exist: 'This session already exists',
  quick_access_path_exist: 'The quick access path already exists',
  sub_account_not_exist: "Check whether the sub-account '{subUin}' exists",
  exist_same_account_user_acl: "Account ID with acl '{uin}' already exist",
  params_duplicate_add: '{params} duplicate',
  region_unreachable_between_fsi_public:
    'There is no communication between the financial region and the public cloud region',
  no_support_copy_MAZ_OAZ: 'DO NOT support copy action between MAZ bucket and OAZ bucket.',
  no_support_between_parent_dir_and_sub: 'Parent directory is not allowed to be copied to subdirectories',
  not_allow_paste_in_origin: 'It is not allowed to paste in the original position',
  file_consistency_check_error: 'Consistency check error',
  file_consistency_check_error_param: '{count} files consistency check error',
  up_to_1000_policy: 'Up to 1000 policies can be set by this account',
  policies_reach_200: 'Policies of user/user group/role reaches 200 limits',
  failed_to_copy_of_network: 'Replication failed: network error',
  tag_cannot_be_empty: 'Tag cannot be empty',
  the_entered_tag_character_is_invalid: 'The entered tag character is invalid',
  modified_file_need_save: 'The file has been modified, please save it and reopen the file.',
  not_support_save_as_encode_param:
    'There are characters in the editing content that do not support saving as {encode}.',
  content_exist_garbled: 'The edited content  may contain unreadable or corrupted characters.',
  not_allowed_edit: 'The file format does not support editing.',
  no_need_to_switch_account: 'Already in this session, no need to switch.',
  not_allow_rename_with_slash: 'Can not name a file with "/"',
  InvalidObjectState: 'The operation is not valid for current object storage class.',
  curr_bucket_not_belongs_to_you: 'The current bucket does not belong to your main account',
  loading_file_acl_timeout: 'Query file permission timed out. ',
  linked_file_does_not_exist: 'Linked file does not exist',
  not_allow_restore_file_open: 'The file is archive storage and cannot be opened',
  delete_replication_before_suspend_versioning: 'Before you suspends versioning, please delete all replication rules',
  curr_region_not_support_operator: 'The operation is temporarily not supported in the current region. You can use the COS Console (or COSBrowser client)',
  curr_region_not_support_rw_Share: 'Read-Write Share operation is temporarily not supported in the current region.',

  // 调用 SCF 函数返回的自定义错误
  'SCF.Timeout': 'Import timed out, please try again',
  'Downloader.TooLarge': 'The resource exceeds 50M and cannot be imported',
  'Downloader.WriteStreamError': 'Resource import failed',
  'Downloader.HttpRequestError': 'The requested resource cannot be imported',
  'Downloader.UrlNotFound': 'The provided resource not found. Resource import failed.',
  'ZipExtractor.GetEntriesError': 'Resource import failed',
  'Traverse.GetFilesError': 'Resource import failed',
  RequestError: 'The network is busy, please try again later',

  region_image_slim_unsupport: 'Ultra-intelligent compression is not currently supported in this region',
  get_access_denied: 'No query permission',
  ups_app_not_exist: 'Data Image Processing service has not been activated. Please bind Data Image Processing first.',
  ups_app_not_exist_html: 'Data Image Processing service has not been activated. Please <a href="https://console.cloud.tencent.com/ci" target="_blank">bind Data Image Processing</a> first.',
};
